/**
 * @file HidAckPolicy.ts
 * @description HID EEPROM 协议 ACK 校验策略。
 * ACK 判断属于协议规则，不属于普通工具函数，也不属于 feature。
 */

import { DeviceError, DeviceErrorCode } from '../../../../errors/DeviceError'
import type { ProtocolConfig } from '../../../../types/protocol'

/**
 * 创建 ACK 校验函数。
 */
export function createHidAckChecker(config: ProtocolConfig): (data: DataView) => void {
  return function checkACK(data: DataView): void {
    const ack = data.getUint8(0)
    if (ack !== config.read_ack_value) {
      throw new DeviceError(
        DeviceErrorCode.READ_FAILED,
        `ACK Error: Expected 0x${config.read_ack_value.toString(16)}, got 0x${ack.toString(16)}`,
      )
    }
  }
}

/**
 * 判断设备是否仍处于忙碌状态。
 */
export function isHidBusyAck(config: ProtocolConfig, data: DataView): boolean {
  return data.getUint8(0) === config.busy_ack_value
}
